<template>
    
    <div class="main">
        <i>
            Atenção! Os alunos que já tiveram a sua matrícula renovada para o ano letivo de 2026, 
            porém não foram aprovadas em 2025, você deverá realizar uma nova enturmação em 2026 por meio da coluna: <b>Nova Enturmação em 2026</b>
        </i>

        <c-panel>
            <situacao-academica></situacao-academica>
        </c-panel>
    </div>
    
</template>
<script>

import situacaoAcademica from "./situacao-academica"

export default {
    components:{ situacaoAcademica }
}
</script>
